import React from "react";
import { inject, observer } from "mobx-react";
import { values } from "mobx";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";

import {
  Avatar,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography
} from "@material-ui/core";

import { blue } from "@material-ui/core/colors";
import { PersonIcon } from "@material-ui/icons/Person";

const styles = theme => ({
  dialogAvatar: {
    backgroundColor: blue[100],
    color: blue[600]
  },
  chipList: {
    direction: "row",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5)
    }
  },
  pageName: {
    fontWeight: "bold"
  },
  progressContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});

class ViewSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      altToken: null,
      loading: true,
      dialogOpen: false,
      dialogUsers: []
    };
  }

  setLoading(loading) {
    this.setState({ loading: loading });
  }

  setDialogUsers(users) {
    this.setState({ dialogUsers: users });
  }

  setDialogOpen(e) {
    this.setState({ dialogOpen: e });
  }

  setToken(token) {
    this.setState({ altToken: token });
  }

  componentDidMount() {
    this.props.rootStore.authStore
      .getUsers()
      .then(() => this.setLoading(false));
  }

  handleOrgSelection(org) {
    this.setLoading(true);
    const users = values(this.props.users)
      .filter(u => (u.organization || {}).id === org.id)
      .sort((a, b) => a.username.localeCompare(b.username));
    this.setDialogUsers(users);
    this.setLoading(false);
    this.setDialogOpen(true);
  }

  handleUserSelect(user) {
    this.setToken(user.token);
  }

  redirectToDemo() {
    this.props.rootStore.authStore
      .bootstrap(this.state.altToken)
      .then(() => (window.location.href = "/"));
  }

  handleDialogClose() {
    this.setToken(null);
    this.setDialogOpen(false);
  }

  render() {
    const classes = this.props.classes;
    const organizations = this.props.rootStore.authStore.sortedOrganizations();

    if (this.state.loading) {
      return (
        <div className={classes.progressContainer}>
          <CircularProgress className={classes.progress} />
        </div>
      );
    }

    return (
      <>
        <Grid justify="space-between" alignItems="center" container>
          <Grid item key="pageName">
            <Typography variant="h4" className={classes.pageName}>
              Demo Mode View Selector
            </Typography>
          </Grid>
        </Grid>

        <br />

        <Dialog
          open={this.state.dialogOpen}
          onClose={() => this.handleDialogClose()}
        >
          <DialogTitle>{"Start a demo session?"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              This will redirect you to a dashboard session for the selected
              client. To return to admin dashboard, log out and then use your
              admin credentials as normal.
            </DialogContentText>
            <Grid container className={classes.chipList}>
              {this.state.dialogUsers.map(u => (
                <Grid item key={u.id}>
                  <Chip
                    label={u.username}
                    variant="outlined"
                    disabled={this.props.user.username === u.username}
                    avatar={
                      <Avatar
                        icon={PersonIcon}
                        className={classes.dialogAvatar}
                      />
                    }
                    onClick={() => this.handleUserSelect(u)}
                  />
                </Grid>
              ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={this.state.altToken === null}
              onClick={() => this.redirectToDemo()}
              color="primary"
              variant="contained"
            >
              Continue
            </Button>
            <Button
              onClick={() => this.handleDialogClose()}
              color="secondary"
              autoFocus
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Typography paragraph={true}>Select an organization.</Typography>

        <Grid container className={classes.chipList}>
          {organizations.map(o => (
            <Grid item key={o.id}>
              <Chip
                label={o.name}
                avatar={<Avatar>{o.name.toUpperCase().charAt(0)}</Avatar>}
                onClick={() => this.handleOrgSelection(o)}
                color="primary"
              />
            </Grid>
          ))}
        </Grid>
      </>
    );
  }
}

export default withRouter(
  withStyles(styles)(
    inject(stores => ({
      rootStore: stores.rootStore,
      user: stores.rootStore.authStore.user,
      users: stores.rootStore.authStore.users
    }))(observer(ViewSelector))
  )
);
